import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _IconCross;
var _excluded = ["children", "onDismiss", "margin", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import { classNamePropTypes, addClassNames } from '../customPropTypes/classNames';
import { addSpacingClasses, marginPropTypes } from '../customPropTypes/spacing';
import IconCross from '../Icon/IconCross';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AnnouncementBar(_ref) {
  var children = _ref.children,
    onDismiss = _ref.onDismiss,
    margin = _ref.margin,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var cssClasses = ['st_announcement-bar'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_jsxs("div", _extends({
    className: cssClasses.join(' '),
    role: "alert"
  }, otherProps, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "st_announcement-bar__content",
      children: children
    }), /*#__PURE__*/_jsx("button", {
      className: "st_announcement-bar__button st_focusable",
      onClick: onDismiss,
      type: "button",
      "aria-label": "Close",
      children: _IconCross || (_IconCross = /*#__PURE__*/_jsx(IconCross, {
        size: "mlg"
      }))
    })]
  }));
}
process.env.NODE_ENV !== "production" ? AnnouncementBar.propTypes = {
  /** callback when announcement is dismissed */
  onDismiss: PropTypes.func.isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes
} : void 0;
AnnouncementBar.defaultProps = {
  className: null,
  margin: null
};
export default AnnouncementBar;